import { Enterprise } from "./enterprise.model";
import { Person } from "./person.model";

export class Customer extends Person {
    id?: number;
    customerName?: string;
    enterprise?: any;
    domains?: any[];
}